import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const footerLinks = {
  Platform: [
    { label: 'Explore Projects', path: '/portfolio' },
    { label: 'Read the Blog',    path: '/blog' },
    { label: 'Mentorship',       path: '/mentorship' },
    { label: 'Testimonials',     path: '/testimonials' },
  ],
  Company: [
    { label: 'About Labora', path: '/about' },
    { label: 'Our Mission',  path: '/about' },
    { label: 'Core Values',  path: '/about' },
    { label: 'Start a Project', path: '/signup' },
  ],
  Community: [
    { label: 'Guidelines',       path: '/about' },
    { label: 'Open Data Policy', path: '/about' },
    { label: 'Collaborations',   path: '/portfolio' },
    { label: 'Newsletter',       path: '/' },
  ],
};

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.accentLine} />

    <div className={styles.inner}>
      {/* ── Brand column ── */}
      <div className={styles.brand}>
        <Link to="/" className={styles.logo}>
          <svg className={styles.logoIcon} viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <path
              d="M11 4h10M13 4v9.5L6.5 22a5 5 0 004.3 7.5h10.4A5 5 0 0025.5 22L19 13.5V4"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
            <circle cx="12.5" cy="22.5" r="1.5" fill="currentColor" opacity="0.7" />
            <circle cx="18"   cy="24.5" r="1"   fill="currentColor" opacity="0.5" />
            <circle cx="15"   cy="20.5" r="1"   fill="currentColor" opacity="0.6" />
          </svg>
          <span className={styles.logoText}>Labora</span>
        </Link>
        <p className={styles.tagline}>
          Science without filters. Document your research in real time — failures, breakthroughs, and everything between.
        </p>
        <div className={styles.githubLink}>
          <a href="https://github.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="GitHub">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/>
            </svg>
            <span>Open source on GitHub</span>
          </a>
        </div>
      </div>

      {/* ── Link Columns ── */}
      {Object.entries(footerLinks).map(([section, links]) => (
        <div key={section} className={styles.column}>
          <h4 className={styles.columnTitle}>{section}</h4>
          <ul className={styles.linkList}>
            {links.map(({ label, path }) => (
              <li key={label}>
                <Link to={path} className={styles.footerLink}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    {/* ── Bottom bar ── */}
    <div className={styles.bottom}>
      <div className={styles.bottomInner}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Labora. Open science for everyone.
        </p>
        <div className={styles.bottomLinks}>
          <a href="/" className={styles.bottomLink}>Privacy</a>
          <a href="/" className={styles.bottomLink}>Terms</a>
          <a href="/" className={styles.bottomLink}>Open Data Policy</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
